(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');
      this.headerSecondaryMenu = document.querySelector('.header-secondary-menu') || null;
      this.announcementBar = document.querySelector('.announcement-bar-section') || null;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerSearchDesktop = document.querySelector('.header_search_input');
      this.headerMobileSearch = document.querySelector('.header_mobile_search');
      this.headerSearchRevealButton = document.querySelector('.js-header-search-button');
      this.annPlusSecondaryHeight = 0;
      this.annPlusSecondaryHeight = (this.headerSecondaryMenu ? this.headerSecondaryMenu.offsetHeight : 0) + (this.announcementBar ? this.announcementBar.offsetHeight : 0);
      this.isMobile = window.innerWidth <= 1199;

      this.setHeaderHeight();

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth <= 1199;
        this.setHeaderHeight();
      });

      if (this.headerSearchDesktop) {
        this.calcHeaderSearchInputPosition();
        window.addEventListener('resize', () => {
          this.calcHeaderSearchInputPosition();
        });
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.headerMobileSearch.classList.add('page-loaded');
      this.onScroll();

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
        const annSecondaryHeaderHeight = this.header.offsetHeight + (this.headerSecondaryMenu ? this.headerSecondaryMenu.offsetHeight : 0) + (this.announcementBar ? this.announcementBar.offsetHeight : 0);
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--ann-secondary-header-height', `${annSecondaryHeaderHeight}px`);
        document.documentElement.style.setProperty('--ann-secondary-header-height-mobile', `${annSecondaryHeaderHeight}px`);
    }

    calcHeaderSearchInputPosition() {
      // need to calculate how far from right of the screen is the search input element
      const headerSearchInputRect = this.headerSearchDesktop.getBoundingClientRect();

      this.headerSearchDesktop.style.setProperty('--header-search-input-position-right', `${headerSearchInputRect.right}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let scrollPastEl = null;

      if(this.isMobile) {
        scrollPastEl = this.header || null;
      } else {
        scrollPastEl = this.headerSecondaryMenu || this.announcementBar || null;
      }

      if (scrollPastEl) {
        const scrollPastElBoundsBottom = scrollPastEl.getBoundingClientRect().bottom;
        if (this.isMobile) {
          if (scrollTop >= scrollPastElBoundsBottom) {
            this.header.classList.add('scrolled-past-secondary-or-ann');
          } else {
            this.header.classList.remove('scrolled-past-secondary-or-ann');
            if(this.headerSearchDesktop) {
              this.headerSearchDesktop.classList.remove('show-on-click');
            }
            if(this.headerMobileSearch) {
              this.headerMobileSearch.classList.remove('show-on-click');
            }
            if(this.headerSearchRevealButton) {
              this.headerSearchRevealButton.classList.remove('hidden-on-click');
            }
          }
        } else {
          if (scrollPastElBoundsBottom <= 0) {
            this.header.classList.add('scrolled-past-secondary-or-ann');
          } else {
            this.header.classList.remove('scrolled-past-secondary-or-ann');
            if(this.headerSearchDesktop) {
              this.headerSearchDesktop.classList.remove('show-on-click');
            }
            if(this.headerMobileSearch) {
              this.headerMobileSearch.classList.remove('show-on-click');
            }
            if(this.headerSearchRevealButton) {
              this.headerSearchRevealButton.classList.remove('hidden-on-click');
            }
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class SearchBarRevealButton extends HTMLElement {
    constructor() {
      super();
      this.searchButton = this
      this.headerMobileSearchBar  = document.querySelectorAll('.header_mobile_search');
      this.headerDesktopSearchBar  = document.querySelectorAll('.header_search_input');

      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
      this.headerMobileSearchBar.forEach((searchBar) => {
        searchBar.classList.add('show-on-click');
      });
      this.headerDesktopSearchBar.forEach((searchBar) => {
        searchBar.classList.add('show-on-click');
      });
      this.classList.add('hidden-on-click');
    }
  }
  customElements.define('search-bar-reveal-button', SearchBarRevealButton);

  class SearchBarCloseButton extends HTMLElement {
    constructor() {
      super();
      this.searchRevealButton = document.querySelector('search-bar-reveal-button');
      this.headerMobileSearchBar  = document.querySelector('.header_mobile_search');
      this.headerDesktopSearchBar  = document.querySelector('.header_search_input');

      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
      this.headerMobileSearchBar.classList.remove('show-on-click');
      this.headerDesktopSearchBar.classList.remove('show-on-click');
      this.searchRevealButton.classList.remove('hidden-on-click');
    }
  }
  customElements.define('search-bar-close-button', SearchBarCloseButton);

  } catch(e) { console.error(e); }
})();
})();
